import HeroLayout from 'components/hero-layout'
import {heroSectionData} from 'content/home-page'

export default function Hero() {
  return (
    <div>
      <HeroLayout
        data={heroSectionData}
        showExtraSection={true}
        customParentStyle={{paddingBottom: '10rem'}}
      />
    </div>
  )
}
